import NewFeatureBadge from './NewFeatureBadge'

export default NewFeatureBadge
